<template>
  <div style="width: 100%;height: 100%;" v-loading ="loading"  element-loading-text="数据加载中，请稍后"  :style="{overflow: loading ? 'hidden' : 'auto'}">
<!--    v-loading.body ="loading"-->
<!--    {{ path}}-->
    <div class="m-content-display"  style="min-height: 100%">
      <div class="m-router-view">
        <TaskDetail :analyzeId="analyzeId" :path="path" :projectId="projectId"></TaskDetail>
        <Modify :analyzeId="analyzeId" :path="path" :projectId="projectId"  ></Modify>
      </div>
      <el-footer style="margin-top: 20px;height:40px">
        <Footers></Footers>
      </el-footer>
    </div>

  </div>
</template>
<script>
import TaskDetail from '@/components/TaskDetail'
import FilePdf from "@/components/FilePdf";
import Modify from "@/components/Modify";
import passPdfFile from "@/store/modules/passPdfFile";
import rightMenu from "@/store/modules/rightMenu";
import Footers from "@/components/Footers";
import {getAnalyzeGroupSampleNames, reRunAnalyze} from "@/api/analyze/analyze";
import ReRunAnalyze from "@/components/ReRunAnalyze";
export default {
  name: "AnalyzeContent",
  components: {Modify, FilePdf, TaskDetail,Footers,ReRunAnalyze},
  data() {
    return {
      showReRunAnalyzeDialog:false,
      reRunGroupSample: [],
      analyzeId: '',
      path: '',
      projectId: '',
      isFirstTime: true,
      //是否重跑分析
      isReRunAnalyze:true,

      // loading:true,
    }
  },
  created: function () {
    this.analyzeId = this.$route.query.analyzeId
    this.projectId = this.$route.query.projectId
    this.path = this.$route.query.path

  },
  mounted() {
    this.$store.commit('setModifyLoading', 'pdf')

  },
  computed: {
    loading() {
      return ((rightMenu.state.modifyLoading.pdfLoading)||(rightMenu.state.modifyLoading.paramLoading)||(rightMenu.state.tableLoading))
    }
  },
  methods:{
  }
}

</script>

<style scoped>
/deep/ .el-slider__button-wrapper {
  z-index: 0;
}

.fontTemplate.el-form-item {

}

.notice {
  font-family: "Microsoft YaHei";
  color: #949898 !important;
  font-size: 16px;
}

.scrollbar {
  /*height: calc(100vh - 60px);*/
  height: 100%;
  width: 100%;
  overflow-x: hidden !important;
}
.m-content-display {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.m-router-view {
  flex: 1;
}

</style>
